import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import QuickCard from '../QuickCard';
import QuickDataModal from '../QuickDataModal';
import { ToolIcon } from '../../../../../../common/icons';
import { odometerHelper } from '../../../../../../helpers';

@inject('translationsStore', 'commonStore', 'pagedCollectionStore')
@observer
export default class QuickGroupMaintenances extends Component {
  constructor(props) {
    super(props);

    const { translationsStore, commonStore } = this.props;

    this.emptyValue = '-';
    this.itemsPerPage = 7;
    this.namespacePrefix = 'maintenances';
    this.historicalFnName = 'historyMaintenance';
    this.liveColumns = [
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.maintenances.liveColumns.description'),
        sorter: true
      },
      {
        key: 'remainingKm',
        dataIndex: 'remainingKm',
        title: translationsStore.translate('quickhealth.maintenances.liveColumns.remainingKm'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.remainingKmValue ? (-1 * Math.round(record.remainingKmValue)).toLocaleString() : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'remainingDays',
        dataIndex: 'remainingDays',
        title: translationsStore.translate('quickhealth.maintenances.liveColumns.remainingDays'),
        style: {
          textAlign: 'center',
          whiteSpace: 'nowrap'
        },
        className: 'CenterNoWrap',
        render: (text, record) => {
          if (text !== this.emptyValue) {
            const remainingDaysValue = moment(record.date).diff(moment(), 'days');
            let themeColor = 'var(--green)';
            if (remainingDaysValue < 7) {
              themeColor = 'var(--red-dtc-color)';
            } else if (remainingDaysValue < 30) {
              themeColor = 'var(--orange-dtc-color)';
            }
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ToolIcon color={themeColor} style={{ marginRight: 4 }} />
                <span>{-1 * remainingDaysValue} gg</span>
              </div>
            );
          } else {
            return this.emptyValue;
          }
        },
        sorter: true
      }
    ];
    this.quickColumns = this.liveColumns.map(column => ({ ...column, sorter: false }));
    this.historicalColumns = [
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.maintenances.historicalColumns.description'),
        style: {},
        sorter: true
      },
      {
        key: 'km',
        dataIndex: 'km',
        title: translationsStore.translate('quickhealth.maintenances.historicalColumns.km'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.km ? `${record.km.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'date',
        dataIndex: 'date',
        title: translationsStore.translate('quickhealth.maintenances.historicalColumns.date'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue ? new Date(record.date).toLocaleDateString(commonStore.momentLocale) : this.emptyValue}</div>;
        },
        sorter: true
      }
    ];

    this.defaultBase = {
      keyName: 'maintenances',
      color: 'var(--maintenance-color)',
      caption: translationsStore.translate('quickhealth.maintenances.caption'),
      captionOne: translationsStore.translate('quickhealth.maintenances.captionOne'),
      icon: <ToolIcon style={{ width: '18px', height: '18px' }} />,
      ctaLabel: translationsStore.translate('quickhealth.maintenances.cta'),
      availableColumns: {
        current: this.liveColumns,
        quick: this.quickColumns,
        historical: this.historicalColumns
      },
      collection: undefined
    };

    this.state = {
      modal: {
        visible: false,
        onOk: this.handleToggleDetailed,
        onCancel: this.handleToggleDetailed
      }
    };
  }

  componentDidMount = () => {
    const { car } = this.props;
    if (!!car) {
      this.initCollections(car);
    }
  };

  componentDidUpdate = prevProps => {
    const { car } = this.props;
    if (!!car) {
      if ((!!prevProps.car && prevProps.car.id !== this.props.car.id) || !prevProps.car) {
        this.initCollections(car);
      }
    }
  };

  initCollections = car => {
    const { pagedCollectionStore } = this.props;
    let odometer;
    if (car.odometer && car.odometer.value) {
      odometer = car.odometer.value;
    } else if (car.gpsOdometer && car.gpsOdometer.value) {
      const { initialOdometer, gpsOdometer, gpsOdometerOnDisconnection } = car;
      odometer = odometerHelper.computeOdometer({ initialOdometer, gpsOdometer, gpsOdometerOnDisconnection });
    }
    if (odometer === undefined && car.initialOdometer) {
      odometer = car.initialOdometer;
    }
    let liveHelper = car.maintenances.map(maintenance => ({
      ...maintenance,
      remainingKmValue: odometer > 0 ? maintenance.km - odometer : maintenance.km,
      remainingDaysValue: moment(maintenance.date).diff(moment(), 'days')
    }));
    liveHelper = liveHelper.slice().sort((a, b) => {
      return b.date < a.date ? 1 : -1;
    });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.current`, source: liveHelper, itemsPerPage: this.itemsPerPage, availableInTabs: true });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.quick`, source: liveHelper, limit: 2, availableInTabs: false });
    pagedCollectionStore.init({
      key: `${this.namespacePrefix}.historical`,
      source: { api: [this.historicalFnName, car.id] },
      itemsPerPage: this.itemsPerPage,
      availableInTabs: true
    });
  };

  handleToggleDetailed = () => {
    this.setState(previousState => ({ modal: { ...previousState.modal, visible: !previousState.modal.visible } }));
  };

  render() {
    const { modal } = this.state;

    const baseDetailed = { ...Object.assign({}, this.defaultBase), ctaLabel: undefined };
    const baseQuick = Object.assign({}, this.defaultBase, { rowThreshold: 2, collection: 'quick' });

    return (
      <Fragment>
        <QuickCard data={baseQuick} collection="quick" onShowDetailedClick={this.handleToggleDetailed} namespacedCollection={`${this.namespacePrefix}.quick`} />
        <QuickDataModal data={baseDetailed} modal={modal} namespacePrefix={this.namespacePrefix} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupMaintenances/QuickGroupMaintenances.js